export const Screens = {
  HOME: 'marketplace homepage',
  APPS: 'apps product homepage',
  AGENTS: 'agents product homepage',
  SOLUTIONS_PARTNERS: 'solutions partners homepage',
  SEARCH_RESULTS: 'search results',
  FEATURED: 'featured collections',
  FEATURED_COLLECTION: 'collection search results',
  UMBRELLA_COLLECTION: 'umbrella collection',
  LISTING_DETAILS: 'listing details',
  LISTING_DETAILS_REVIEW: 'listing details review'
};
export const Subscreens = {
  ALL_PRODUCTS_SECTION: 'all products section',
  COLLECTION_SECTION: 'collection section',
  FILTER_BAR: 'filter bar',
  FILTER_PANEL: 'filter panel',
  HERO_SECTION: 'hero section',
  NO_RESULTS: 'no results',
  RESULTS_GRID: 'results grid',
  SEARCH_BAR: 'search bar',
  STOREFRONT_NAVIGATION: 'storefront navigation',
  SUGGESTION_SECTION: 'suggestion section',
  SUGGESTED_COLLECTIONS: 'suggested collections',
  SUGGESTED_ACCREDITATIONS: 'suggested accreditations',
  RECOMMENDED_PARTNERS: 'recommended partners',
  PARTNER_TIER_EXPLAINER: 'partner tier explainer'
};